import { Communication } from '../../../../services/api-client/contact-api';
import { CommStatus } from '../../../../services/api-client/contact-api.types';

export const sortByDateAndStatus = (comms: Communication[]) => comms.sort((a, b) => {
  if (a.status === CommStatus.Scheduled && b.status !== CommStatus.Scheduled) return -1;

  if (a.status !== CommStatus.Scheduled && b.status === CommStatus.Scheduled) return 1;

  const dateA = new Date(a.date);
  const dateB = new Date(b.date);

  return dateB.getTime() - dateA.getTime();
});